<script setup lang="ts">
import type { TooltipTriggerProps } from 'reka-ui';
import { TooltipTrigger as TooltipTriggerPrimitive } from 'reka-ui';

defineOptions({
    name: 'UiTooltipTrigger',
});

const props = defineProps<TooltipTriggerProps>();
</script>

<template>
    <TooltipTriggerPrimitive v-bind="props">
        <slot />
    </TooltipTriggerPrimitive>
</template>
